<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col :span="4" class="cs-main-left-container">
        <navigator></navigator>
      </el-col>
      <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
        <div class="cs-fullHeight cs-contentContainer-right">
          <div class="backgroud-white cs-contentContainer-right-content cs-fullHeight">
            <el-row>
              <el-col>
                <span class="cs-title">真留账目流水</span>
                <runningAccountList></runningAccountList>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss">
</style>

<script>
import navigator from "../../components/navigator";
import runningAccountList from "../../components/studyAbroad/runningAccountList";

export default {
  data() {
    return {
     
    };
  },
  components: {
    navigator,
    runningAccountList,
  },
  created() {
    
  },
  methods: {

  }
};
</script>



// WEBPACK FOOTER //
// src/page/studyAbroad/runningAccount.vue